// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"07630ef5","453":"d7446e4a"}[chunkId] + ".chunk.js";
};